function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import NumberPicker from './numberPicker';
export default function CartLineItem(_ref) {
  var id = _ref.id,
      productUrl = _ref.productUrl,
      productTitle = _ref.productTitle,
      productImgSrc = _ref.productImgSrc,
      isFirst = _ref.isFirst,
      lineItemTitle = _ref.lineItemTitle,
      variantOptions = _ref.variantOptions,
      sellingPlanName = _ref.sellingPlanName,
      originalPrice = _ref.originalPrice,
      finalPrice = _ref.finalPrice,
      originalLinePrice = _ref.originalLinePrice,
      finalLinePrice = _ref.finalLinePrice,
      quantity = _ref.quantity,
      discounts = _ref.discounts,
      onQtyChange = _ref.onQtyChange;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      selectedQuantity = _useState2[0],
      setSelectedQuantity = _useState2[1];

  useEffect(function () {
    setSelectedQuantity(quantity);
  }, [quantity]);

  function formatMoney(amount) {
    return window.Shopify.formatMoney(amount, window.Shopify.money_format);
  }

  function handleQtyChange(lineItemKey) {
    return function (newQty) {
      setSelectedQuantity("".concat(newQty));
      onQtyChange(lineItemKey, newQty);
    };
  }

  function handleRemove() {
    onQtyChange(id, 0);
  }

  return /*#__PURE__*/React.createElement("tr", {
    className: "cart__row border-bottom cart-flex ".concat(isFirst ? 'border-top' : '')
  }, /*#__PURE__*/React.createElement("td", {
    className: "cart__image-wrapper cart-flex-item"
  }, /*#__PURE__*/React.createElement("a", {
    href: productUrl
  }, /*#__PURE__*/React.createElement("img", {
    className: "cart__image",
    src: productImgSrc,
    alt: lineItemTitle
  }))), /*#__PURE__*/React.createElement("td", {
    className: "cart__meta small--text-left cart-flex-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-view-item__title"
  }, /*#__PURE__*/React.createElement("a", {
    href: productUrl,
    "aria-label": lineItemTitle
  }, productTitle)), variantOptions === null || variantOptions === void 0 ? void 0 : variantOptions.map(function (option) {
    return /*#__PURE__*/React.createElement("div", {
      key: option.name,
      className: "cart__meta-text"
    }, option.name, ": ", option.value);
  }), sellingPlanName && /*#__PURE__*/React.createElement("p", {
    className: "selling-plan"
  }, sellingPlanName), /*#__PURE__*/React.createElement("p", {
    className: "small--hide"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn--small btn--secondary",
    "aria-label": "Remove ".concat(lineItemTitle, " from cart"),
    onClick: handleRemove
  }, "Remove"))), /*#__PURE__*/React.createElement("td", {
    className: "cart__price-wrapper cart-flex-item text-right"
  }, originalPrice !== finalPrice && /*#__PURE__*/React.createElement("span", {
    className: "cart-item__original-price"
  }, /*#__PURE__*/React.createElement("s", {
    "aria-hidden": "true"
  }, formatMoney(originalPrice))), /*#__PURE__*/React.createElement("span", {
    className: "cart-item__price"
  }, formatMoney(finalPrice)), discounts === null || discounts === void 0 ? void 0 : discounts.map(function (discount) {
    return /*#__PURE__*/React.createElement("div", {
      key: discount.title,
      className: "cart-item__discount medium-up--hide"
    }, discount.title);
  })), /*#__PURE__*/React.createElement("td", {
    className: "cart__update-wrapper cart-flex-item text-right"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn--small btn--secondary medium-up--hide",
    "aria-label": "Remove ".concat(lineItemTitle, " from cart"),
    onClick: handleRemove
  }, "Remove"), /*#__PURE__*/React.createElement("div", {
    className: "cart__qty"
  }, /*#__PURE__*/React.createElement(NumberPicker, {
    id: "updates_".concat(id),
    value: selectedQuantity,
    inputName: "updates[]",
    onChange: handleQtyChange(id),
    downAriaLabel: "Decrease quantity",
    upAriaLabel: "Increase quantity",
    min: 1,
    max: 1000
  }))), /*#__PURE__*/React.createElement("td", {
    className: "text-right small--hide"
  }, originalLinePrice !== finalLinePrice && /*#__PURE__*/React.createElement("span", {
    className: "cart-item__original-price"
  }, /*#__PURE__*/React.createElement("s", {
    "aria-hidden": "true"
  }, formatMoney(originalLinePrice))), /*#__PURE__*/React.createElement("div", null, formatMoney(finalLinePrice)), discounts === null || discounts === void 0 ? void 0 : discounts.map(function (discount) {
    return /*#__PURE__*/React.createElement("div", {
      key: discount.title,
      className: "cart-item__discount"
    }, discount.title);
  })));
}
CartLineItem.propTypes = {
  id: PropTypes.string,
  productUrl: PropTypes.string,
  productTitle: PropTypes.string,
  productImgSrc: PropTypes.string,
  isFirst: PropTypes.bool,
  lineItemTitle: PropTypes.string,
  variantOptions: PropTypes.arrayOf(PropTypes.object),
  sellingPlanName: PropTypes.string,
  originalPrice: PropTypes.number,
  finalPrice: PropTypes.number,
  originalLinePrice: PropTypes.number,
  finalLinePrice: PropTypes.number,
  quantity: PropTypes.string,
  discounts: PropTypes.arrayOf(PropTypes.shape({
    amount: PropTypes.number,
    title: PropTypes.string
  })),
  onQtyChange: PropTypes.func.isRequired
};